export default () => {
  const flowRequire = require.context(
    '../flows',
    true,
    /\/[^/]+\/index.ts(x)?/
  );
  return flowRequire.keys().map(flowRequire);
};
